module.exports = __webpack_public_path__ + "img/1502173041.38050d28.jpg";